import useTheme from "@mui/material/styles/useTheme";
import { makeStyles } from "@mui/styles";

export const useCustomStyle = () => {
  const theme = useTheme();

  return makeStyles(() => ({
    mainStyleWrapper: {
      "&.mainStyleWrapper": {
        position: "relative",
        maxWidth: "820px",
        margin: "auto",
        "& .textFiled": {
          marginBottom: "40px",
          [theme.breakpoints.down("md")]: {
            marginBottom: "30px",
          },
        },
      },
    },
  }))();
};
